import React, { useEffect } from "react";
import { isMobileOrTablet } from "../../Views/MobileClassRenderer";
import MobileViewGlobal from "../../Views/MobileView";
import EventDebounceInput from "./components/EventDebounceInput";
import EventInviteButton from "./components/EventInviteButton";
import EventQuestionsInput from "./components/EventQuestionsInput";
import EventVisitorList from "./components/EventVisitorList";

export default function EventUserMobileView({
  handleModalTriggerClick,
  setShowModal,
  showModal,
  setSearchValue,
  eventQuestionData,
  renderTypeahead,
  handleInviteToPrivateChatroom,
  fetchEventUserLoadMore,
  getSelectedUsers,
  getFilteredSelectedValues,
  isLoading,
  eventUserList,
  eventUserCount,
  getSearchResultCount,
  handleChange,
  isInviting,
  isInvalidInvite,
  nextUrl,
  MAX_FORM_FIELDS,
  me,
  selectedValues,
  MAX_INVITES,
}) {
  const populateView = () => {
    handleModalTriggerClick();
  };

  useEffect(() => {
    if(isMobileOrTablet()) {
      populateView()
    }
  }, []);

  return (
    <MobileViewGlobal className="user-wrapper">
      <form>
        <div className="user-wrapper__item-new-message">
          <h5>New Message</h5>
          <div className="user-wrapper__item-search">
            <EventDebounceInput setSearchValue={setSearchValue} />
            <EventQuestionsInput
              eventQuestionData={eventQuestionData}
              MAX_FORM_FIELDS={MAX_FORM_FIELDS}
              renderTypeahead={renderTypeahead}
            />
          </div>
          <EventInviteButton
            isInviting={isInviting}
            isInvalidInvite={isInvalidInvite}
            handleInviteToPrivateChatroom={handleInviteToPrivateChatroom}
            getSelectedUsers={getSelectedUsers}
            isMobile={true}
          />
          <div className="user-wrapper__search-message">
            {eventUserCount && getSearchResultCount()} participants matched your
            search.
          </div>
        </div>
      </form>
      <EventVisitorList
        isLoading={isLoading}
        eventUserList={eventUserList}
        fetchEventUserLoadMore={fetchEventUserLoadMore}
        getFilteredSelectedValues={getFilteredSelectedValues}
        selectedValues={selectedValues}
        me={me}
        nextUrl={nextUrl}
        MAX_INVITES={MAX_INVITES}
        handleChange={handleChange}
        isInviting={isInviting}
      />
    </MobileViewGlobal>
  );
}
